<template>
  <ul :class="{ [type]: true }" >
    <li
      v-for="card in cardGroup"
      :class="[{ [card.size]: true }, cardStyle]"
      :key="card.id"
    >
      <card v-bind="card" :type="cardStyle" />
    </li>
  </ul>
</template>

<script>
import TYPES from './group-types'

export default {
  computed: {
    cardGroup () {
      const { cards, type } = this
      let cardGroup = []
      const pattern = this[type]

      if (type === TYPES.ALL
        || type === TYPES.PROMOTIONAL) {
        cardGroup = cards
      } else if (type === TYPES.FEATURED
        || type === TYPES.FEATURED_HOUSE_NOTES
        || type === TYPES.SIMILAR) {
        cardGroup = cards.slice(0, pattern.length)
      } else {
        cardGroup = cards
        return cardGroup.map(card => Object.assign({ size: pattern }, card))
      }
      return cardGroup.map((card, i) => Object.assign({ size: pattern[i % pattern.length] }, card))
    }
  },
  data () {
    return {
      [TYPES.FEATURED]: [
        'featured-hero',
        'featured-secondary',
        'featured-secondary'
      ],
      [TYPES.FEATURED_HOUSE_NOTES]: [
        'featured-hero',
        'featured-block',
        'featured-secondary',
        'featured-secondary'
      ],
      [TYPES.SIMILAR]: [
        'editorial-left',
        'editorial-right',
        'editorial-bleed',
        'editorial-large'
      ],
      [TYPES.PROMOTIONAL]: [
        'editorial-left',
        'editorial-right'
      ],
      [TYPES.ALL]: [
        'event-small',
        'event-small',
        'event-small',
        'event-large',
        'event-small',
        'event-small'
      ],
      [TYPES.MED]: 'event-med',
      [TYPES.SMALL]: 'event-small',
      [TYPES.TINY]: 'event-tiny'
    }
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => Object.values(TYPES).includes(value)
    },
    cardStyle: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>

  ul {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    margin: 0;
    padding: 0;
    clear: both;

    li {
      display: inline-block;
      width: 100%;
      padding: 0 0 $d-small 0;

      @include breakpoint(medium) {
        padding: 0;
      }
    }

    li.featured-secondary {
      @include breakpoint(medium) {
        width: 50%;
        &:nth-last-of-type(2) {
          padding-right: $d-small;
        }
        &:last-of-type {
          padding-left: $d-small;
        }
      }
      @include breakpoint(large) {
        &:nth-last-of-type(2) {
          padding-right: $d-med-large;
        }
        &:last-of-type {
          padding-left: $d-med-large;
        }
      }
    }

    &.featured {
      flex-direction: row;
      flex-wrap: wrap;

      li.featured-hero {
        padding-bottom: $d-small;
        margin-bottom: $d-large;
      }
    }

    &.featured-house-notes {
      flex-direction: row;
      flex-wrap: wrap;

      li.featured-block {
        padding: $d-med 0;
      }
    }

    &.similar,
    &.promotional {
      flex-direction: column;
      flex-wrap: nowrap;

      li {
        @include breakpoint(medium) {
          padding: $d-large 0;
          &:first-of-type {
            padding-top: $d-med;
          }
        }

        @include breakpoint(large) {
          padding: $d-xx-large 0;
        }

        &.editorial-bleed {
          @include breakpoint(medium) {
            width: calc(100% + #{$d-med-large});
          }
          @include breakpoint(large) {
            width: 100%;
          }
        }
      }
    }

    &.all {
      @include breakpoint(small) {
        display: block;
        margin: 0 #{-$d-x-small};

        @supports (display: grid) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }

        li {
          padding: $d-x-small;

          &.event-small {
            float: left;
            width: calc(((100% / 3) - 1px));

            &:nth-child(7) {
              clear: both;
            }

            @supports (display: grid) {
              float: none;
              width: 100%;
              padding-bottom: 0;
            }
          }
        }
      }
      @include breakpoint(medium) {
        margin: 0 #{-$d-small};
        grid-template-columns: repeat(3, 1fr);

        li {
          padding: $d-small;

          &.event-large {
            float: left;
            width: calc(200% / 3);

            @supports (display: grid) {
              float: none;
              width: 100%;
              grid-row: span 2;
              grid-column: span 2;
              padding-bottom: 0;
            }
          }
        }
      }
      @include breakpoint(large) {
        margin: 0 #{-$d-med};

        li {
          padding: $d-med;
          &.event-large {
            @supports (display: grid) {
              grid-row: span 2;
              grid-column: span 2;
            }
          }
        }
      }
    }

    &.med {
      li.event-med {
        flex-grow: 1;
        min-width: 280px;
      }
      @include breakpoint(small) {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        margin-left: -$d-med-small;
        margin-right: -$d-med-small;

        li.event-med {
          width: calc(100% / 2);
          padding: $d-small;
        }
      }

      @include breakpoint(medium) {
        margin-left: -$d-small;
        margin-right: -$d-small;
        li.event-med {
          width: calc(100% / 3 );
          padding: $d-small;
          padding-top: 0;
          &:only-of-type {
            max-width: calc(100% / 3);
          }
          &:nth-last-child(4):first-child,
          &:nth-last-child(4):first-child ~ li {
            max-width: calc(100% / 3);
          }
        }
      }
      @include breakpoint(large) {
        margin-left: -$d-med;
        margin-right: -$d-med;
        li.event-med {
          padding: $d-med;
          padding-top: 0;
        }
      }
    }

    &.tiny {
      li {
        padding: 0 0 $d-x-small 0;
      }
    }
  }
</style>
